<div *ngIf="isActive" class="tab">
  <ng-content></ng-content>
</div>
